import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { useState, useEffect } from "react";
import { postApi } from "../../Helpers/Axios";
import toast from "react-hot-toast";

const ApproveMemberModal = ({ show, onHide, member, onSuccess }) => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (member) {
      setFormData({
        name_en: member.name_en || "",
        name_gj: member.name_gj || "",
        email: member.email || "",
        mobile_1: member.mobile_1 || "",
        city: member.city || "",
      });
    }
  }, [member]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleApprove = async () => {
    setLoading(true);
    try {
      const res = await postApi(`approve-member?status_id=${member.id}`, formData, true);

      if (res.status === 200) {
        toast.success("Member Approved");
        onSuccess();
        onHide();
      }
    } catch (err) {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleDecline = async () => {
    setLoading(true);
    try {
      const res = await postApi(`decline-member?status_id=${member.id}`, {}, true);

      if (res.status === 200) {
        toast.success("Member Declined");
        onSuccess();
        onHide();
      }
    } catch (err) {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  if (!member) return null;

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Approve Member</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Row className="mb-3">
            <Col>
              <Form.Label>Name (English)</Form.Label>
              <Form.Control name="name_en" disabled={true} value={formData.name_en} onChange={handleChange} />
            </Col>
            <Col>
              <Form.Label>Name (Gujarati)</Form.Label>
              <Form.Control name="name_gj" disabled={true} value={formData.name_gj} onChange={handleChange} />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col>
              <Form.Label>Email</Form.Label>
              <Form.Control name="email" disabled={true} value={formData.email} onChange={handleChange} />
            </Col>
            <Col>
              <Form.Label>Mobile</Form.Label>
              <Form.Control name="mobile_1" disabled={true} value={formData.mobile_1} onChange={handleChange} />
            </Col>
          </Row>

          <Row>
            <Col>
              <Form.Label>City</Form.Label>
              <Form.Control name="city" value={formData.city} onChange={handleChange} />
            </Col>
          </Row>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleDecline} disabled={loading}>
          Decline
        </Button>
        <Button variant="success" onClick={handleApprove} disabled={loading}>
          Approve
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ApproveMemberModal;
